import { render, staticRenderFns } from "./TemplateParamsFilter.vue?vue&type=template&id=2a2ba087&"
import script from "./TemplateParamsFilter.vue?vue&type=script&lang=ts&"
export * from "./TemplateParamsFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports